// The last line against a page navigating its frame out of the proxy. Scramjet hands the page a
// location object of its own, but the browser's real one can still be reached:
// Reflect.get(window, "location"), Object.getOwnPropertyDescriptor(document, "location").get,
// the same from a frame made by script, and its href setter and assign()/replace() cannot be
// replaced (they are [LegacyUnforgeable]). A site's address set there loads directly, outside
// the proxy, with the visitor's own address: Lamoda's bot check (ServicePipe) did that.
//
// Every navigation of this window, however it was started, first fires the Navigation API's
// navigate event, here, before any of the page's listeners (this runs before the page's code).
// One that would leave the proxy's origin is cancelled and made again through the proxy;
// downloads too. One that cannot be made again (a form's POST) is only cancelled.

import { ScramjetClient } from "@client/index";

export default function (client: ScramjetClient, self: Self) {
	const navigation = (self as any).navigation;
	if (!navigation) return;
	const own = client.context.prefix.origin;

	const listener = (event: any) => {
		let dest: URL;
		try {
			// the browser's address, not the one Scramjet gives the page (browserapis.ts)
			dest = new URL(
				client.descriptors.get(
					"NavigationDestination.prototype.url",
					event.destination
				) as string
			);
		} catch {
			return;
		}
		const leaves =
			((dest.protocol === "http:" || dest.protocol === "https:") &&
				dest.origin !== own) ||
			dest.protocol === "data:";
		if (!leaves || !event.cancelable) return;
		event.preventDefault();
		if (event.formData) return;
		const proxied = client.rewriteUrl(dest.href, { navigateType: "location" });
		if (event.downloadRequest !== null && event.downloadRequest !== undefined) {
			const a = client.natives.call(
				"Document.prototype.createElement",
				self.document,
				"a"
			) as HTMLAnchorElement;
			client.natives.call("Element.prototype.setAttribute", a, "href", proxied);
			client.natives.call(
				"Element.prototype.setAttribute",
				a,
				"download",
				String(event.downloadRequest)
			);
			client.natives.call("HTMLElement.prototype.click", a);

			return;
		}
		const location = client.descriptors.get("window.location", self) as Location;
		if (event.navigationType === "replace") location.replace(proxied);
		else location.assign(proxied);
	};
	client.natives.call(
		"EventTarget.prototype.addEventListener",
		navigation,
		"navigate",
		listener
	);
}
